import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminConnections = lazy(() => import("@/pages/admin/AdminConnections"));

export const Route = createFileRoute("/admin/connections")({
  component: AdminConnections,
});
